<!--Title Section-->
<app-title-jumbo title="Web Seminars" comment="Real-time communications as well as multicast communications available"></app-title-jumbo>

<div class="my-container">
  <section>
    <div class="container">
      <div class="offset-1 col-10">

        <!--Carousel Wrapper-->
        <div id="carousel-example-2" class="col-12 carousel slide carousel-fade" data-ride="carousel">
          <!--Slides-->
          <div class="carousel-inner" role="listbox">
            <div class="carousel-item active">
              <div class="view">
                <img class="d-block w-100 h-100" src="assets/img/webinars_2.jpeg" alt="Webinar">
                <div class="mask rgba-black-slight"></div>
              </div>
              <div class="carousel-caption text-left" style="height:300px; width:88%">
                <div class="offset-2 col-9 py-4 px-4 h-100" style="background: rgba(0,0,0,0.75)">
                  <img src="assets/img/10.jpg" class="float-left" style="height:185px; margin-right:15px" alt="Anna Aston - MSCI">

                  Factor investing has brought disruptive change to the asset management industry. The effects were first felt in equities, but Factor investing is now going multi-asset class. Factor-based asset allocation and systematic strategy factors are starting to push beyond equity selection. The next webinar in our Factor Investing series will highlight our latest Factor Innovation, the MSCI Multi-Asset Class Factor Model, which helps investors more clearly identify the drivers of risk and return in these complex, dynamic strategies.

                </div>
              </div>
            </div>
            <div class="carousel-item">
              <div class="view">
                <img class="d-block w-100 h-100" src="assets/img/edhec-risk-conference.jpg" alt="Risk Conference">
                <div class="mask rgba-black-slight"></div>
              </div>
              <div class="carousel-caption text-left" style="height:300px; width:88%">
                <div class="offset-2 col-9 py-4 px-4 h-100" style="background: rgba(0,0,0,0.75)">
                  <img src="assets/img/10.jpg" class="float-left" style="height:185px; margin-right:15px" alt="Anna Aston - BlackRock">

                  In our 30-minute session, we’ll examine how factors have historically driven returns across asset classes, how to use factors to seek resilience, and simple ways to explain them to your clients.

                </div>
              </div>
            </div>
            <div class="carousel-item">
              <div class="view">
                <img class="d-block w-100 h-100" src="assets/img/webinars_3.jpeg" alt="Webinar">
                <div class="mask rgba-black-slight"></div>
              </div>
              <div class="carousel-caption text-left" style="height:300px; width:88%">
                <div class="offset-2 col-9 py-4 px-4 h-100" style="background: rgba(0,0,0,0.75)">
                  <img src="assets/img/10.jpg" class="float-left" style="height:185px; margin-right:15px" alt="Anna Aston - FTSE">

                  The new FTSE Target Exposure Indexes are a suite of benchmarks designed to focus on specific characteristics— such as factor, climate and ESG exposures—while minimizing all off-target, consequential exposures, to deliver a “near pure” index. Target exposures are completely flexible and can be combined to cater to specific client objectives and investment outcomes.

                </div>
              </div>
            </div>
          </div>
          <!--/.Slides-->

          <br />

          <div class="row">
            <div class="col-6" style="height:330px">
              <!--Descriptions-->
              <div class="carousel-description-2 h-100">
                <div class="col h-100">
                  <app-title header="Details" title="MSCI Factor Investing Webinar Series" priority="4"></app-title>

                  As we believe that smart beta is a new frontier for the investment industry, research and education on this subject are a core part of our strategy. We have therefore also made available our series of webinars on the subject of smart beta investing on our corporate YouTube channel...

                  <br><br>
                  <em style="font-size: 0.8em;">January 21st, 2019</em>

                  <div class="row">
                    <div class="col-10">
                      <span class="float-right">
                        <app-line-button green>Watch now</app-line-button>
                      </span>
                    </div>
                  </div>

                  <br />
                </div>

                <div class="col h-100 d-none">
                  <app-title header="Details" title="Getting started with Factor Investing" priority="4"></app-title>

                  This webinar will review Smart Beta's defensive offering which is motivated by a strong belief that investors are not identical and that their investment objectives and constraints are different. The Smart Beta approach allows investors to benefit from the Low Volatility factor reward...

                  <br><br>
                  <em style="font-size: 0.8em;">April 4th, 2019 – 4.00pm</em>

                  <div class="row">
                    <div class="col-10">
                      <span class="float-right">
                        <app-line-button green>Watch now</app-line-button>
                      </span>
                    </div>
                  </div>

                  <br />
                </div>

                <div class="col h-100 d-none">
                  <app-title header="Details" title="Eliminate the noise of “off-target” exposure" priority="4"></app-title>

                  As we believe that smart beta is a new frontier for the investment industry, research and education on this subject are a core part of our strategy. We have therefore also made available our series of webinars on the subject of smart beta investing on our corporate YouTube channel...

                  <br><br>

                  <em style="font-size: 0.8em;">January 17th, 2019 – 4.00pm</em>

                  <div class="row">
                    <div class="col-10">
                      <span class="float-right">
                        <app-line-button green>Watch now</app-line-button>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!--Descriptions-->
            </div>

            <!--Controls-->
            <div class="col pl-5" style="height:330px; border-left: 1px solid #aaa">
              <small class="card-text">Recent resources</small>
              <br /><br />
              <em style="font-size: 0.8em;">Anna Aston - MSCI – January 21st, 2019</em>
              <a class="blue-link" (click)="showResourcesSlide(1)"><h5 class="text-primary">Webinar series also available on our corporate YouTube channel</h5></a>
              <br />
              <em style="font-size: 0.8em;">Anna Aston - BlackRock – April 4th, 2019 – 4.00pm</em>
              <a class="blue-link" (click)="showResourcesSlide(0)"><h5 class="text-primary">A More Robust Defensive Offering</h5></a>
              <br />
              <em style="font-size: 0.8em;">Anna Aston - FTSE – January 17th, 2019 – 4.00pm</em>
              <a class="blue-link" (click)="showResourcesSlide(2)"><h5 class="text-primary">On the Importance of Taking Hidden Risks into Account for Factor Investing</h5></a>
            </div>
          </div>
          <!--Controls-->
        </div>
        <!--/.Carousel Wrapper-->

      </div>
    </div>

  </section>

</div>
